import gql from 'graphql-tag';

import embeddedDokkioTagFragment from './embeddedDokkioTagFragment';
import dokkioObjectDokkioTagFragment from './dokkioObjectDokkioTagFragment';
import taskFragment from './taskFragment';

export const dokkioItemFragment = gql`
  fragment dokkioItemFragment on DokkioItem {
    dokkioClass
    id
    accountID
    dokkioItemType
    remoteID
    description
    logoID
    suggestionCount
    webClippingURL
    imageCaption
    summary
    dokkioTags {
      ...embeddedDokkioTagFragment
    }
    dokkioObjectDokkioTags {
      ...dokkioObjectDokkioTagFragment
    }
    dokkioTagIDs
    tasks {
      ...taskFragment
    }
  }
  ${dokkioObjectDokkioTagFragment}
  ${embeddedDokkioTagFragment}
  ${taskFragment}
`;
export default dokkioItemFragment;
